export default "/images/Plastics.webp?18a7595844e23e25e4da3008c00bc66e";